"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourOfferingDtoBuilder = void 0;
var base_offering_dto_builder_1 = require("./base-offering.dto.builder");
var offering_dto_1 = require("./offering.dto");
var TourOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(TourOfferingDtoBuilder, _super);
    function TourOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TourOfferingDtoBuilder.prototype.getOfferingType = function () {
        return offering_dto_1.OfferingType.TOUR;
    };
    TourOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign({}, baseOfferingDto);
    };
    TourOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        return this;
    };
    TourOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return TourOfferingDtoBuilder;
}(base_offering_dto_builder_1.BaseOfferingDtoBuilder));
exports.TourOfferingDtoBuilder = TourOfferingDtoBuilder;
//# sourceMappingURL=tour-offering.dto.builder.js.map